<script lang='ts'>
  import * as _ from 'lodash';
  import ImageUploadWidget from '@shared/svelte/Components/ImageUploadWidget.svelte';
  import ProductImage from '@shared/svelte/Components/ProductImage.svelte';
  import { selectAlternatives } from '@distributor/svelte/Storefront/Utils/AlternativesUtils.svelte';
  import type { ImageObj } from '@shared/types/Images';
  import type { Storefront, StorefrontFeaturedProduct} from '@shared/types/Storefront';
  export let storefront : Storefront;
  export let callbacks: any;
  export let orientation : string = 'featured';
  export let alternative:boolean = false;

  let chosenProduct : StorefrontFeaturedProduct;
  let imageObj : ImageObj;
  let proviImageObj : ImageObj;

  const enabledProp:string = orientation == 'featured' ? 'enable_featured_product' : 'enable_featured_items'

  function showProductChooser() {
    callbacks.showProductChooser({
      storefront: storefront,
      onSelectProduct: onSelectProduct,
    })
  }

  function update() {
    callbacks.update(storefront);
  }

  function onSelectProduct(plid: any) {
    let toSend: any;
    if (chosenProduct) {
      toSend = [
        {
          id: chosenProduct.id,
          product_line_id: plid,
          orientation: orientation
        }
      ]
    } else {
      toSend = [
        {
          product_line_id: plid,
          orientation: orientation,
          alternative_index: alternative ? 1 : 0
        }
      ]
    }
    storefront.storefront_featured_products_attributes = toSend;
    update();
  };

  function removePLChoice() {
    storefront.storefront_featured_products_attributes = [{
      id: chosenProduct.id,
      _destroy: true
    }];
    update();
  };

  function toggleImageOverride(event: any) {
    if (event && event.srcElement) {
      chosenProduct.use_provi_image = event.srcElement.checked;
    }
    update();
  }

  function postRemoveImageCB() {
    callbacks.refreshStorefront();
  };

  function saveImageWrapper() {
    chosenProduct.use_provi_image = false;
    delete chosenProduct.image_upload_id;
    update();
  };

  const dimensions = {
    min_width: 640,
    min_height: 375,
    max_file_size: 5
  }

  $: {
    let chosenProducts:StorefrontFeaturedProduct[] = selectAlternatives(storefront, orientation);
    chosenProduct = alternative ? chosenProducts[1] : chosenProducts[0]
    if (chosenProduct) {
      imageObj = {cloudinary_image_url: _.get(chosenProduct, 'cloudinary_url'),
      id: chosenProduct.id, image_upload_id: chosenProduct.image_upload_id};
      proviImageObj = {cloudinary_image_url: _.get(chosenProduct, 'product_line.cloudinary_image_url')};
    }
  }
</script>

{#if storefront[enabledProp]}
  {#if !chosenProduct || !chosenProduct.product_line}
    <button class="fizz-button-small fizz-margin-auto fizz-modal-toggle {orientation == 'left' ? 'fizz-stack-16' : ''}" id='select-{orientation}' on:click={showProductChooser}>Select Product</button>
  {:else if chosenProduct.product_line}
    <figure class='fizz-flex-row fizz-stack-16'>
      <ProductImage product={proviImageObj} eTrimMode={chosenProduct.use_provi_image} className='nothing' height={55} width={55} fizz={true}
        ></ProductImage>
      <figcaption>
        <p>
          <strong>{(chosenProduct.product_line || {}).name}</strong>
        </p>
      </figcaption>
    </figure>
    <div class='fizz-flex-row fizz-stack-16'>
      <button class="fizz-button-small fizz-flex-item" on:click={showProductChooser}>Change</button>
      <button class="fizz-button-small fizz-flex-item" on:click={removePLChoice}>Remove</button>
    </div>

    <p class="fizz-label fizz-stack-8 fizz-space-between">
      <span>Header</span>
    </p>
    <textarea class="fizz-textarea fizz-stack-16" rows={2}
      id='featured-product-header-{orientation}'
      bind:value={chosenProduct.header}
      on:change={update}
      type="text"
    ></textarea>
    {#if orientation == 'featured'}
      <p class="fizz-label fizz-stack-8 fizz-space-between">
        <span>Description</span>
      </p>
      <textarea class="fizz-textarea fizz-stack-16" rows={3}
        id='featured-product-description-{orientation}'
        bind:value={chosenProduct.description}
        on:change={update}
        type="text"
      ></textarea>
    {/if}

    <p class="fizz-label fizz-stack-8 fizz-space-between">
      <span>Product Image</span>
    </p>

    {#if orientation != 'featured'}
      <label class="fizz-flex-row-8 fizz-stack-16">
        <input type="checkbox" class="fizz-checkbox"
          on:click={toggleImageOverride}
          bind:checked={chosenProduct.use_provi_image}>
        <span>Display Provi's product image</span>
      </label>
    {/if}

    <ImageUploadWidget obj={imageObj} entityType='StorefrontFeaturedProduct' setLoading={callbacks.setLoading}
      postRemoveCB={postRemoveImageCB} postSaveCB={saveImageWrapper} {dimensions}></ImageUploadWidget>
  {/if}
{/if}